// Angular
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

// Formly
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-printbreak',
    templateUrl: './printbreak.wrapper.component.html',
    styleUrls: ['./printbreak.wrapper.component.scss'],
})
export class PrintBreakWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { static: true, read: ViewContainerRef }) fieldComponent: ViewContainerRef;
}
